let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6NGzB")).then(() => parcelRequire('7HAe3'));